import { render, staticRenderFns } from "./ScholarEntityDetail.vue?vue&type=template&id=73422104&scoped=true&"
import script from "./ScholarEntityDetail.vue?vue&type=script&lang=js&"
export * from "./ScholarEntityDetail.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=73422104&prod&lang=less&scoped=true&"
import style1 from "./ScholarEntityDetail.vue?vue&type=style&index=1&id=73422104&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73422104",
  null
  
)

export default component.exports